import { Controller, useFormContext } from 'react-hook-form';

import { Box, Stack, Heading2, u } from '@ui';
import { useTranslate } from '@i18n';

import { CameraAngleButtons, PlaybackSpeedButtonGroup, InstantPlayback } from './components';
import * as css from './FloorSettingsSection.css';

export const FloorSettings = () => {
    const { control } = useFormContext();
    const t = useTranslate();

    return (
        <Box gap={u(6)} p={u(2)} className={css.root}>
            <Heading2>{t('user_settings.floor_screen_section')}</Heading2>
            <Box className={css.settingsWrapper}>
                <Stack height="min-content" className={css.bordered}>
                    <Controller
                        name="instantPlayback"
                        control={control}
                        render={({ field }) => (
                            <InstantPlayback
                                label={t('user_settings.instant_playback')}
                                isActive={field.value}
                                onUpdate={field.onChange}
                            />
                        )}
                    />
                    <Controller
                        name="playbackSpeed"
                        control={control}
                        render={({ field }) => (
                            <PlaybackSpeedButtonGroup selectedPlaybackSpeed={field.value} onUpdate={field.onChange} />
                        )}
                    />
                </Stack>
                <Controller
                    name="cameraAngle"
                    control={control}
                    render={({ field }) => <CameraAngleButtons activeAngle={field.value} onUpdate={field.onChange} />}
                />
            </Box>
        </Box>
    );
};
